export type UnauthorizedHandler = () => void;
export type LegalAcceptanceRequiredHandler = () => void;

let handler: UnauthorizedHandler | null = null;
let legalAcceptanceRequiredHandler: LegalAcceptanceRequiredHandler | null = null;

export const authSessionBus = {
  setUnauthorizedHandler(next: UnauthorizedHandler | null) { handler = next; },
  triggerUnauthorized() { handler?.(); },
  setLegalAcceptanceRequiredHandler(next: LegalAcceptanceRequiredHandler | null) { legalAcceptanceRequiredHandler = next; },
  triggerLegalAcceptanceRequired() { legalAcceptanceRequiredHandler?.(); },
};
